// import React, { useState } from 'react';
import {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {getAdminDashboardService, addressAddressDetails, addressAndRatingDetails, ActivityLogDetails} from "../../services/adminServices";
import {addressCommentDetails} from "../../services/adminServices";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import CustomUserName from "../../CustomComponents/CustomUserName";
import CustomRatingStar from "../../CustomComponents/CustomRatingStar";
import {fDate, fDateTime} from "../../utils/format-time";
import {getActivityActionBadge, getStatusBadge, getTypeCommentsBadge, truncateWords} from "../../utils/format-text";

const DashboardHome = () => {
	const name = localStorage.getItem("first_name") + " " + localStorage.getItem("last_name");

	const [counts, setCounts] = useState({});

	const getData = async () => {
		try {
			const response = await getAdminDashboardService({});
			setCounts(response?.data.counts);
		} catch (error) {}
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div className="dashboard-home">
			<div className="welcome-section d-flex justify-content-between">
				<div>
					<h2>Welcome, {name}!</h2>
					<p>Here's what's happening with your ratings and recommendations.</p>
				</div>
			</div>

			<div className="stats-grid">
				<Link to="/admin-dashboard/ratings" className="stat-card card text-decoration-none p-2">
					<div className="d-flex gap-4 align-items-center">
						<div className="stat-icon stat-icon-primary">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</div>
						<div className="stat-content">
							<div className="stat-number" >
								{counts?.ratingsCount || 0}
							</div>
							<div className="stat-label" style={{fontSize: "x-small"}}>
								Total Ratings
							</div>
						</div>
					</div>
				</Link>

				<Link to="/admin-dashboard/comments" className="stat-card card text-decoration-none p-2">
					{/* <div className="stat-icon stat-icon-info">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
					<div className="stat-content">
						<div className="stat-number">{counts?.commentCount || 0}</div>
						<div className="stat-label">Total Comments</div>
					</div> */}
					<div className="d-flex gap-4 align-items-center">
						<div className="stat-icon stat-icon-info">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</div>
						<div className="stat-content">
							<div className="stat-number">{counts?.commentCount || 0}</div>
							<div className="stat-label" style={{fontSize: "x-small"}}>
								Total Comments
							</div>
						</div>
					</div>
				</Link>

				<div className="stat-card card text-decoration-none p-2">
					{/* <div className="stat-icon stat-icon-danger">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M10.29 3.86L1.82 18C1.64 18.37 1.54 18.78 1.54 19.2C1.54 19.62 1.64 20.03 1.82 20.4C2 20.77 2.26 21.09 2.59 21.33C2.92 21.57 3.31 21.73 3.72 21.8C4.13 21.87 4.55 21.85 4.95 21.75C5.35 21.65 5.72 21.47 6.04 21.22L12 17.27L17.96 21.22C18.28 21.47 18.65 21.65 19.05 21.75C19.45 21.85 19.87 21.87 20.28 21.8C20.69 21.73 21.08 21.57 21.41 21.33C21.74 21.09 22 20.77 22.18 20.4C22.36 20.03 22.46 19.62 22.46 19.2C22.46 18.78 22.36 18.37 22.18 18L13.71 3.86C13.53 3.49 13.27 3.17 12.94 2.93C12.61 2.69 12.22 2.53 11.81 2.46C11.4 2.39 10.98 2.41 10.58 2.51C10.18 2.61 9.81 2.79 9.49 3.04C9.17 3.29 8.91 3.61 8.73 3.98C8.55 4.35 8.45 4.76 8.45 5.18C8.45 5.6 8.55 6.01 8.73 6.38L10.29 3.86Z"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<path d="M12 9V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							<path d="M12 17H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
					</div>
					<div className="stat-content">
						<div className="stat-number">{counts?.flaggedCount || 0}</div>
						<div className="stat-label">Flagged Ratings</div>
					</div> */}

					<div className="d-flex gap-4 align-items-center">
						<div className="stat-icon stat-icon-danger">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M10.29 3.86L1.82 18C1.64 18.37 1.54 18.78 1.54 19.2C1.54 19.62 1.64 20.03 1.82 20.4C2 20.77 2.26 21.09 2.59 21.33C2.92 21.57 3.31 21.73 3.72 21.8C4.13 21.87 4.55 21.85 4.95 21.75C5.35 21.65 5.72 21.47 6.04 21.22L12 17.27L17.96 21.22C18.28 21.47 18.65 21.65 19.05 21.75C19.45 21.85 19.87 21.87 20.28 21.8C20.69 21.73 21.08 21.57 21.41 21.33C21.74 21.09 22 20.77 22.18 20.4C22.36 20.03 22.46 19.62 22.46 19.2C22.46 18.78 22.36 18.37 22.18 18L13.71 3.86C13.53 3.49 13.27 3.17 12.94 2.93C12.61 2.69 12.22 2.53 11.81 2.46C11.4 2.39 10.98 2.41 10.58 2.51C10.18 2.61 9.81 2.79 9.49 3.04C9.17 3.29 8.91 3.61 8.73 3.98C8.55 4.35 8.45 4.76 8.45 5.18C8.45 5.6 8.55 6.01 8.73 6.38L10.29 3.86Z"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path d="M12 9V13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								<path d="M12 17H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
							</svg>
						</div>
						<div className="stat-content">
							<div className="stat-number">{counts?.flaggedCount || 0}</div>
							<div className="stat-label" style={{fontSize: "x-small"}}>
								Flagged Ratings
							</div>
						</div>
					</div>
				</div>

				<Link to="/admin-dashboard/contractor" className="stat-card card text-decoration-none p-2">
					{/* <div className="stat-icon stat-icon-success">
						<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
							<g fill="currentColor" fillRule="evenodd" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
								<path
									d="M13.689 11.132c1.155 1.222 1.953 2.879 2.183 4.748a1.007 1.007 0 0 1-1 1.12H3.007a1.005 1.005 0 0 1-1-1.12c.23-1.87 1.028-3.526 2.183-4.748c.247.228.505.442.782.633c-1.038 1.069-1.765 2.55-1.972 4.237L14.872 16c-.204-1.686-.93-3.166-1.966-4.235a7 7 0 0 0 .783-.633M8.939 1c1.9 0 3 2 4.38 2.633a2.48 2.48 0 0 1-1.88.867c-.298 0-.579-.06-.844-.157A3.73 3.73 0 0 1 7.69 5.75c-1.395 0-3.75.25-3.245-1.903C5.94 3 6.952 1 8.94 1"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
								<path
									d="M8.94 2c2.205 0 4 1.794 4 4s-1.795 4-4 4c-2.207 0-4-1.794-4-4s1.793-4 4-4m0 9A5 5 0 1 0 8.937.999A5 5 0 0 0 8.94 11"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</g>
						</svg>
					</div>
					<div className="stat-content">
						<div className="stat-number">{counts?.contractorCount || 0}</div>
						<div className="stat-label">Total Contractors</div>
					</div> */}

					<div className="d-flex gap-4 align-items-center">
						<div className="stat-icon stat-icon-success">
							<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
								<g fill="currentColor" fillRule="evenodd" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
									<path
										d="M13.689 11.132c1.155 1.222 1.953 2.879 2.183 4.748a1.007 1.007 0 0 1-1 1.12H3.007a1.005 1.005 0 0 1-1-1.12c.23-1.87 1.028-3.526 2.183-4.748c.247.228.505.442.782.633c-1.038 1.069-1.765 2.55-1.972 4.237L14.872 16c-.204-1.686-.93-3.166-1.966-4.235a7 7 0 0 0 .783-.633M8.939 1c1.9 0 3 2 4.38 2.633a2.48 2.48 0 0 1-1.88.867c-.298 0-.579-.06-.844-.157A3.73 3.73 0 0 1 7.69 5.75c-1.395 0-3.75.25-3.245-1.903C5.94 3 6.952 1 8.94 1"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M8.94 2c2.205 0 4 1.794 4 4s-1.795 4-4 4c-2.207 0-4-1.794-4-4s1.793-4 4-4m0 9A5 5 0 1 0 8.937.999A5 5 0 0 0 8.94 11"
										stroke="currentColor"
										strokeWidth="2"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</g>
							</svg>
						</div>
						<div className="stat-content">
							<div className="stat-number">{counts?.contractorCount || 0}</div>
							<div className="stat-label" style={{fontSize: "x-small"}}>
								Total Contractors
							</div>
						</div>
					</div>
				</Link>

				<Link to="/admin-dashboard/address" className="stat-card card text-decoration-none p-2">
					{/* <div className="stat-icon stat-icon-warning">
						<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
							<path
								d="m19.799 5.165l-2.375-1.83a2 2 0 0 0-.521-.237A2 2 0 0 0 16.336 3H9.5l.801 5h6.035c.164 0 .369-.037.566-.098s.387-.145.521-.236l2.375-1.832c.135-.091.202-.212.202-.334s-.067-.243-.201-.335M8.5 1h-1a.5.5 0 0 0-.5.5V5H3.664c-.166 0-.37.037-.567.099c-.198.06-.387.143-.521.236L.201 7.165C.066 7.256 0 7.378 0 7.5c0 .121.066.242.201.335l2.375 1.832c.134.091.323.175.521.235c.197.061.401.098.567.098H7v8.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-17a.5.5 0 0 0-.5-.5"
								fill="currentColor"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
						</svg>
					</div>
					<div className="stat-content">
						<div className="stat-number">{counts?.addressCount || 0}</div>
						<div className="stat-label">Total Addresses</div>
					</div> */}

					<div className="d-flex gap-4 align-items-center">
						<div className="stat-icon stat-icon-danger">
							<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
								<path
									d="m19.799 5.165l-2.375-1.83a2 2 0 0 0-.521-.237A2 2 0 0 0 16.336 3H9.5l.801 5h6.035c.164 0 .369-.037.566-.098s.387-.145.521-.236l2.375-1.832c.135-.091.202-.212.202-.334s-.067-.243-.201-.335M8.5 1h-1a.5.5 0 0 0-.5.5V5H3.664c-.166 0-.37.037-.567.099c-.198.06-.387.143-.521.236L.201 7.165C.066 7.256 0 7.378 0 7.5c0 .121.066.242.201.335l2.375 1.832c.134.091.323.175.521.235c.197.061.401.098.567.098H7v8.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-17a.5.5 0 0 0-.5-.5"
									fill="currentColor"
									stroke="currentColor"
									strokeWidth="2"
									strokeLinecap="round"
									strokeLinejoin="round"
								/>
							</svg>
						</div>
						<div className="stat-content">
							<div className="stat-number">{counts?.addressCount || 0}</div>
							<div className="stat-label" style={{fontSize: "x-small"}}>
								Total Addresses
							</div>
						</div>
					</div>
				</Link>
			</div>

			<div className="quick-actions">
				<h3>Quick Actions</h3>
				<div className="action-buttons">
					<Link to="/admin-dashboard/address" className="action-btn action-btn-primary">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						View All Addresses
					</Link>
					<Link to="/admin-dashboard/comments" className="action-btn action-btn-secondary">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						View All Comments
					</Link>
					<Link to="/admin-dashboard/ratings" className="action-btn action-btn-primary">
						<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						</svg>
						View All Ratings
					</Link>
				</div>
			</div>

			<div className="recent-ratings card">
				<h3>Recent Addresses</h3>
				<RecentAddress />
				<div className="table-footer">
					<Link to="/admin-dashboard/address" className="view-all-link">
						View All Addresses →
					</Link>
				</div>
			</div>

			<div className="recent-ratings">
				<h3>Recent Ratings</h3>
				<RecentRatings />
				<div className="table-footer">
					<Link to="/admin-dashboard/ratings" className="view-all-link">
						View All Ratings →
					</Link>
				</div>
			</div>

			<div className="recent-ratings">
				<h3>Recent Comments</h3>
				<RecentComments />
				<div className="table-footer">
					<Link to="/admin-dashboard/comments" className="view-all-link">
						View All Comments →
					</Link>
				</div>
			</div>

			<div className="recent-ratings">
				<h3>Recent Activities</h3>
				<RecentActivity />
				<div className="table-footer">
					<Link to="/admin-dashboard/activity-log" className="view-all-link">
						View All Activities →
					</Link>
				</div>
			</div>
		</div>
	);
};

const RecentAddress = () => {
	const headCells = [
		{id: "jobsite", label: "Job Site", width: "200px"},
		{id: "username", label: "User Name", width: "150px"},
		{id: "rating", label: "Rating", width: "150px"},
		{id: "submitted", label: "Submitted", width: "150px"},
	];

	useEffect(() => {
		addressAddressDetails({page: 1, pagesize: 5})
			.then((res) => {
				if (res?.status) {
					setList(res?.data?.list || []);
				}
			})
			.catch(() => {});
	}, []);

	const [list, setList] = useState([]);

	return (
		<Paper sx={{width: "100%", overflow: "hidden"}}>
			<TableContainer>
				<Table aria-labelledby="ratings table" sx={{minWidth: 750}}>
					<TableHead className="">
						<TableRow>
							{headCells.map((headCell) => (
								<TableCell key={headCell.id} sx={{fontWeight: 600, width: headCell.width}}>
									{headCell.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{list.map((row, index) => (
							<TableRow hover key={index}>
								<TableCell>{truncateWords(row?.full_address, 35) || "-"}</TableCell>
								<TableCell>
									<CustomUserName user={row?.user} />
								</TableCell>
								<TableCell sx={{alignItems: "center"}}>
									<CustomRatingStar star={row?.aggregate_rating} />
								</TableCell>
								<TableCell>{fDate(row?.createdAt)} </TableCell>
							</TableRow>
						))}

						{list.length === 0 && (
							<TableRow>
								<TableCell colSpan={headCells.length}>
									<Typography align="center" sx={{py: 2}}>
										No Recode found
									</Typography>
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};

const RecentRatings = () => {
	const headCells = [
		{id: "jobsite", label: "Job Site", width: "200px"},
		{id: "username", label: "User Name", width: "150px"},
		{id: "hobdate", label: "Job Date", width: "100px"},
		{id: "status", label: "Status", width: "100px"},
		{id: "rating", label: "Rating", width: "100px"},
	];

	useEffect(() => {
		addressAndRatingDetails({page: 1, pagesize: 5})
			.then((res) => {
				if (res?.status) {
					setList(res?.data?.list || []);
				}
			})
			.catch(() => {});
	}, []);

	const [list, setList] = useState([]);

	return (
		<Paper sx={{width: "100%", overflow: "hidden"}}>
			<TableContainer>
				<Table aria-labelledby="ratings table" sx={{minWidth: 750}}>
					<TableHead className="">
						<TableRow>
							{headCells.map((headCell) => (
								<TableCell key={headCell.id} sx={{fontWeight: 600, width: headCell.width}}>
									{headCell.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{list.map((row, index) => (
							<TableRow hover key={index}>
								<TableCell>{truncateWords(row?.address?.full_address, 35) || "N/A"}</TableCell>
								<TableCell>
									<CustomUserName user={row?.user} />
								</TableCell>
								<TableCell>{fDate(row?.job_date)} </TableCell>
								<TableCell>{getStatusBadge(row?.is_historic, row?.admin_flagged)} </TableCell>
								<TableCell sx={{alignItems: "center"}}>
									<CustomRatingStar star={row?.stars} />
								</TableCell>
							</TableRow>
						))}

						{list.length === 0 && (
							<TableRow>
								<TableCell colSpan={headCells.length}>
									<Typography align="center" sx={{py: 2}}>
										No Recode found
									</Typography>
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};

const RecentComments = () => {
	const headCells = [
		{id: "streetzipcode", label: "Street/Zipcode", width: "200px"},
		{id: "username", label: "User Name", width: "150px"},
		{id: "hobdate", label: "Job Date", width: "100px"},
		{id: "rating", label: "Type", width: "100px"},
		{id: "status", label: "Status", width: "100px"},
	];

	useEffect(() => {
		addressCommentDetails({page: 1, pagesize: 5})
			.then((res) => {
				if (res?.status) {
					setList(res?.data?.list || []);
				}
			})
			.catch(() => {});
	}, []);

	const [list, setList] = useState([]);

	return (
		<Paper sx={{width: "100%", overflow: "hidden"}}>
			<TableContainer>
				<Table aria-labelledby="ratings table" sx={{minWidth: 750}}>
					<TableHead className="">
						<TableRow>
							{headCells.map((headCell) => (
								<TableCell key={headCell.id} sx={{fontWeight: 600, width: headCell.width}}>
									{headCell.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{list.map((row, index) => (
							<TableRow hover key={index}>
								<TableCell>{truncateWords(row?.comment?.full_address || "Comment to Reply", 35) || "N/A"}</TableCell>
								<TableCell>
									{" "}
									<CustomUserName user={row?.user} />{" "}
								</TableCell>
								<TableCell>{fDate(row?.comment_date)} </TableCell>
								<TableCell>{getTypeCommentsBadge(row?.comment_type)} </TableCell>
								<TableCell>{getStatusBadge(row?.is_historic, row?.admin_flagged)} </TableCell>
							</TableRow>
						))}

						{list.length === 0 && (
							<TableRow>
								<TableCell colSpan={headCells.length}>
									<Typography align="center" sx={{py: 2}}>
										No Recode found
									</Typography>
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};

const RecentActivity = () => {
	const headCells = [
		{id: "username", label: "User Name", width: "150px"},
		{id: "activitymodel", label: "Activity Model", width: "150px"},
		{id: "activitytype", label: "Activity Type", width: "100px"},
		{id: "ipaddress", label: "IP Address", width: "100px"},
		{id: "activitytime", label: "Activity Time", width: "100px"},
	];

	const labelMap = {
		activity_log: "Activity",
		addresses: "Addresses",
		feedback: "Feedback",
		likes: "Likes",
		login_log: "Login Log",
		notifications: "Notifications",
		rating: "Rating",
		session: "Session",
		street_comment: "Comments",
		uplift: "Uplift",
		users: "Users",
	};

	useEffect(() => {
		ActivityLogDetails({page: 1, pagesize: 5})
			.then((res) => {
				if (res?.status) {
					setList(res?.data?.list || []);
				}
			})
			.catch(() => {});
	}, []);

	const [list, setList] = useState([]);

	return (
		<Paper sx={{width: "100%", overflow: "hidden"}}>
			<TableContainer>
				<Table aria-labelledby="ratings table" sx={{minWidth: 750}}>
					<TableHead className="">
						<TableRow>
							{headCells.map((headCell) => (
								<TableCell key={headCell.id} sx={{fontWeight: 600, width: headCell.width}}>
									{headCell.label}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{list.map((row, index) => (
							<TableRow hover key={index}>
								<TableCell>
									<CustomUserName user={row?.user} />
								</TableCell>
								<TableCell>{labelMap[row?.model]}</TableCell>
								<TableCell>{getActivityActionBadge(row?.action)}</TableCell>
								<TableCell>{truncateWords(row?.ip_address, 35) || "N/A"}</TableCell>
								<TableCell>{fDateTime(row?.createdAt)} </TableCell>
							</TableRow>
						))}

						{list.length === 0 && (
							<TableRow>
								<TableCell colSpan={headCells.length}>
									<Typography align="center" sx={{py: 2}}>
										No Recode found
									</Typography>
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};

export default DashboardHome;
